<template>
  <div>
    <v-btn class="exit-icon red-background" dark small @click="onCloseRPT">Close Preview</v-btn>
    <v-btn :disabled="state == 'LOADING'" class="genrpt" dark small @click="onPrint">Generate Report</v-btn>&nbsp;

    <md-card id="rptpreview" class="md-with-hover" style="margin: 20px; padding: 20px">
      <!-- <md-icon class="exit-icon">close</md-icon> -->
      <md-card-content>
        <div id="dispense-report">
          <!-- PDF REPORT (START) -->
          <div id="pdf" style="margin: 7px">
            <article id="heading">
              <section style="visibility: hidden">
                <span>GlobeChek, LLC</span> <br />
                <span>1-877-GlobeChek</span> <br />
                <span>www.GlobeChek.com</span>
              </section>
              <section class="gclogo">
                <img src="@/assets/img/GlobeChek2.png" alt="GlobeChek" id="gclogo" class="img-responsive" />
              </section>
              <section>
                <span>GlobeChek, LLC</span> <br />
                <span>1-877-GlobeChek</span> <br />
                <span>www.GlobeChek.com</span>
              </section>
            </article>

            <br />

            <article id="member">
              <section>
                <dl id="info-screen">
                  <dt>Name</dt>
                  <dd>{{ eval.patientInfo.firstName }}&nbsp;{{ eval.patientInfo.lastName }}</dd>
                  <dt>Scan ID</dt>
                  <dd>{{ eval.screeningInfo.globeId }}-{{ screeningID.slice(0, 8) }}</dd>
                  <dt>Scan Date</dt>
                  <dd>{{ getScreenDate }}</dd>
                </dl>
              </section>
              <section>
                <dl id="info-address">
                  <dt>Address</dt>
                  <br />
                  <dd>
                    {{ eval.patientInfo.address.addressLn1 }}
                    {{ eval.patientInfo.address.addressLn2 }}
                  </dd>
                  <br />
                  <dd>
                    {{ eval.patientInfo.address.city }} &nbsp; {{ eval.patientInfo.address.state }} &nbsp;
                    {{ eval.patientInfo.address.zip }} &nbsp;
                  </dd>
                </dl>
              </section>
              <section>
                <dl id="info-member">
                  <dt>DOB</dt>
                  <dd>{{ getDob }} ({{ getAge }})</dd>
                  <dt>Email</dt>
                  <dd>{{ eval.patientInfo.email }}</dd>
                  <dt>Cell</dt>
                  <dd>{{ eval.patientInfo.phone }}</dd>
                </dl>
              </section>
            </article>

            <hr style="margin-bottom: 5px" />

            <article id="screening">
              <section>
                <dl id="screening-title">
                  <dt>&nbsp;</dt>
                  <dt class="mtitle">Vision:</dt>
                  <dt style="font-size: 0.75rem">&nbsp;</dt>
                  <!--SPACER-->
                  <dt>&nbsp;</dt>
                  <dt class="mtitle">Wavefront Auto Refraction:</dt>
                  <dt class="spacer title">&nbsp;</dt>
                  <!--SPACER-->
                  <dt>&nbsp;</dt>
                  <dt class="mtitle">Anterior Segment OCT:</dt>
                  <dt class="spacer">&nbsp;</dt>
                  <!--SPACER-->
                  <dt>&nbsp;</dt>
                  <dt class="mtitle" style="margin-top: 5px">Intra Ocular Pressure:</dt>
                  <dt>&nbsp;</dt>
                </dl>
              </section>

              <section>
                <dl id="screening-subtitle">
                  <dt>&nbsp;</dt>
                  <dt class="rl-top">Right Eye:</dt>
                  <dt class="spacer rl-top">Left Eye:</dt>
                  <!--SPACER-->
                  <dt>&nbsp;</dt>
                  <dt class="rl-top">Right Eye:</dt>
                  <dt class="spacer rl-top">Left Eye:</dt>
                  <!--SPACER-->
                  <dt>&nbsp;</dt>
                  <dt class="rl-top">Right Eye:</dt>
                  <dt class="spacer rl-top">Left Eye:</dt>
                  <!--SPACER-->
                  <dt>&nbsp;</dt>
                  <dt class="rl-top">Right Eye:</dt>
                  <dt class="rl-top">Left Eye:</dt>
                </dl>
              </section>

              <section>
                <dl id="screening-col1">
                  <dt class="heading">Distance VA</dt>
                  (<b>{{ eval.visionInfo.acuityWCorrectionD }}</b>)
                  <dd>{{ eval.visionInfo.acuityDistanceOD }}</dd>
                  <dd class="spacer">{{ eval.visionInfo.acuityDistanceOS }}</dd>
                  <!--SPACER-->
                  <dt class="heading">Sphere</dt>
                  <dd>{{ OD_Sph }}</dd>
                  <dd class="spacer">{{ OS_Sph }}</dd>
                  <!--SPACER-->
                  <dt class="heading spacer2">Angle</dt>
                  <dd v-html="OD_Angle" />
                  <!--{{ eval.visionInfo.angleMeasurementOD }}-->
                  <dd v-html="OS_Angle" />
                  <!--{{ eval.visionInfo.angleMeasurementOS }}-->

                  <!--SPACER-->
                  <dt class="heading spacer2" style="margin-top: 5px">Eye Pressure</dt>
                  <dd>{{ eval.visionInfo.eyePressureOD }}</dd>
                  <dd>{{ eval.visionInfo.eyePressureOS }}</dd>
                </dl>
              </section>

              <section>
                <dl id="screening-col2">
                  <dt class="heading">Near VA</dt>
                  (<b>{{ eval.visionInfo.acuityWCorrectionN }}</b>)
                  <dd>{{ eval.visionInfo.acuityNearOD }}</dd>
                  <dd class="spacer">{{ eval.visionInfo.acuityNearOS }}</dd>
                  <!--SPACER-->
                  <dt class="heading">Cylider</dt>
                  <dd>{{ OD_Cyl }}</dd>
                  <dd class="spacer">{{ OS_Cyl }}</dd>
                  <!--SPACER-->
                  <dt class="heading">Thickness</dt>
                  <dd>{{ eval.visionInfo.anteriorThicknessOD }}</dd>
                  <dd class="spacer">
                    {{ eval.visionInfo.anteriorThicknessOS }}
                  </dd>
                  <!--SPACER-->
                  <dt class="heading" style="margin-top: 2px">Corrected IOP</dt>
                  <dd>{{ eval.visionInfo.correctedIOP_OD }}</dd>
                  <dd>{{ eval.visionInfo.correctedIOP_OS }}</dd>
                </dl>
              </section>

              <section>
                <dl id="screening-col3">
                  <dt>&nbsp;</dt>
                  <dd>&nbsp;</dd>
                  <dd class="spacer">&nbsp;</dd>
                  <!--SPACER-->
                  <dt class="heading">Axis</dt>
                  <dd>{{ OD_Axis }}</dd>
                  <dd class="spacer">{{ OS_Axis }}</dd>
                  <!--SPACER-->
                  <dt class="heading">
                    Pupillary Distance <span style="color: green">&nbsp;{{ pupillaryDistanceAGG }}</span>
                  </dt>
                  <dd>{{ pupillaryDistance_OD }}</dd>
                  <dd class="spacer">{{ pupillaryDistance_OS }}</dd>
                  <!--SPACER-->
                  <dt>&nbsp;</dt>
                  <dd>&nbsp;</dd>
                  <dd class="spacer">&nbsp;</dd>
                  <!--SPACER-->
                  <dt>&nbsp;</dt>
                  <dd>&nbsp;</dd>
                  <dd>&nbsp;</dd>
                </dl>
              </section>

              <section>
                <dl id="screening-col4">
                  <dt>&nbsp;</dt>
                  <dd>&nbsp;</dd>
                  <dd>&nbsp;</dd>
                  <dt class="spacer">&nbsp;</dt>
                  <!--SPACER-->
                  <dt>&nbsp;</dt>
                  <dd>
                    <i><!--* Not valid for eye glasses--></i>
                  </dd>
                  <dd>
                    <i><!--prescription--></i>
                  </dd>
                  <dt class="spacer">&nbsp;</dt>
                  <!--SPACER-->
                  <dt>&nbsp;</dt>
                  <dd>&nbsp;</dd>
                  <dd>&nbsp;</dd>
                  <dt class="spacer">&nbsp;</dt>
                  <!--SPACER-->
                </dl>
              </section>
            </article>

            <hr style="margin-top: 10px; margin-bottom: 5px" />

            <!--EXTERNAL & CORNEAL TOPOGRAPHY PHOTO-->
            <table class="report" style="width: 100%">
              <tbody>
                <tr align="right" style="line-height: 10px">
                  <td class="label" align="left" colspan="2">External Photo:</td>
                  <td class="label" align="left" colspan="2">Wavefront Corneal Topography:</td>
                </tr>
                <tr align="right" style="line-height: 12px">
                  <td align="left" colspan="2">
                    <p class="field-rl">&nbsp;</p>

                    <img v-if="imgExt" :src="imgExt" class="img-responsive" alt="External Photo Image"
                      style="width: 250px" />
                    <img v-else src="@/assets/img/imageNA.jpg" class="img-responsive" alt="External Photo Image"
                      style="width: 250px" />

                    <div v-if="externalPhoto.findingsOD[0] === 'Normal' && externalPhoto.findingsOS[0] === 'Normal'">
                      <p class="field-norm">NORMAL</p>
                    </div>
                    <div v-else class="imgdiag">
                      <div v-if="externalPhoto.findingsOD[0] != 'Normal' && externalPhoto.findingsOD.length > 0">
                        <span style="color: red; line-height: 12px">
                          <b style="font-weight: bold">OD:</b> {{ externalPhoto.findingsOD.join(", ") }}</span>
                      </div>
                      <br />
                      <div v-if="externalPhoto.findingsOS[0] != 'Normal' && externalPhoto.findingsOS.length > 0">
                        <span style="color: red; line-height: 12px">
                          <b style="font-weight: bold">OS:</b> {{ externalPhoto.findingsOS.join(", ") }}</span>
                      </div>
                      <br />
                    </div>
                  </td>

                  <td align="left">
                    <p class="field-rl">Right Eye</p>

                    <img v-if="imgCorOD" :src="imgCorOD" class="img-responsive" alt="Corneal Topography Right"
                      style="width: 190px" />
                    <img v-else src="@/assets/img/imageNA.jpg" class="img-responsive" alt="Corneal Topography Right"
                      style="width: 250px" />

                    <div v-if="corneaPhoto.findingsOD[0] === 'Normal'">
                      <p class="field-norm">NORMAL</p>
                    </div>
                    <div v-else class="imgdiag">
                      <div v-if="corneaPhoto.findingsOD.length > 0">
                        <span style="color: red; line-height: 12px">{{ corneaPhoto.findingsOD.join(", ") }}</span>
                      </div>
                    </div>
                  </td>
                  <td align="left">
                    <p class="field-rl">Left Eye</p>

                    <img v-if="imgCorOS" :src="imgCorOS" class="img-responsive" alt="Corneal Topography LEFT"
                      style="width: 190px" />
                    <img v-else src="@/assets/img/imageNA.jpg" class="img-responsive" alt="Corneal Topography LEFT"
                      style="width: 250px" />

                    <div v-if="corneaPhoto.findingsOS[0] === 'Normal'">
                      <p class="field-norm">NORMAL</p>
                    </div>

                    <div v-else class="imgdiag">
                      <div v-if="corneaPhoto.findingsOS.length > 0">
                        <span style="color: red; line-height: 12px">{{ corneaPhoto.findingsOS.join(", ") }}</span>
                      </div>
                      <br />
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>

            <hr style="margin-top: 5px; margin-bottom: 3px" />

            <!--PACHYMETRY-->
            <table class="report" style="width: 100%">
              <tbody>
                <tr align="right" style="line-height: 12px">
                  <td class="label" align="left">Anterior Segment OCT and Pachymetry:</td>
                  <td class="label" align="left">&nbsp;</td>
                </tr>
                <tr align="right" style="line-height: 12px">
                  <td align="center">
                    <p class="field-rl">Right Eye</p>

                    <img v-if="imgPacOD" :src="imgPacOD" class="img-responsive" alt="Pachymetry Image OD"
                      style="width: 320px" />
                    <img v-else src="@/assets/img/imageNA.jpg" class="img-responsive" alt="Pachymetry Image OD"
                      style="width: 250px" />

                    <div v-if="pachymetryPhoto.findingsOD[0] === 'Normal'">
                      <p class="field-norm">NORMAL</p>
                    </div>

                    <div v-else class="imgdiag">
                      <div v-if="pachymetryPhoto.findingsOD.length > 0">
                        <span style="color: red; line-height: 12px">{{ pachymetryPhoto.findingsOD.join(", ") }}</span>
                      </div>
                      <br />
                    </div>
                  </td>
                  <td align="center">
                    <p class="field-rl">Left Eye</p>

                    <img v-if="imgPacOS" :src="imgPacOS" class="img-responsive" alt="Pachymetry Image OS"
                      style="width: 320px" />
                    <img v-else src="@/assets/img/imageNA.jpg" class="img-responsive" alt="Pachymetry Image OS"
                      style="width: 250px" />

                    <div v-if="pachymetryPhoto.findingsOS[0] === 'Normal'">
                      <p class="field-norm">NORMAL</p>
                    </div>
                    <div v-else class="imgdiag">
                      <div v-if="pachymetryPhoto.findingsOS.length > 0">
                        <span style="color: red; line-height: 12px">{{ pachymetryPhoto.findingsOS.join(", ") }}</span>
                      </div>
                      <br />
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>

            <h2>&nbsp;</h2>
            <br />
            <hr style="margin-top: 0px; margin-bottom: 3px" />

            <!--OPACITY-->
            <table v-if="imgOpaOS" class="report" style="width: 100%">
              <tbody>
                <tr align="right" style="line-height: 12px">
                  <td class="label" align="left">Lens Opacity / Cataract Grading:</td>
                  <td class="label" align="left">&nbsp;</td>
                </tr>
                <tr align="right" style="line-height: 12px">
                  <td align="center">
                    <p class="field-rl">Right Eye</p>

                    <img v-if="imgOpaOD" :src="imgOpaOD" class="img-responsive" alt="Lens Opacity Image OD"
                      style="width: 300px" />
                    <img v-else src="@/assets/img/imageNA.jpg" class="img-responsive" alt="Lens Opacity Image OD"
                      style="width: 250px" />

                    <div v-if="opacityPhoto.findingsOD[0] === 'Normal'">
                      <p class="field-norm">NORMAL</p>
                    </div>
                    <div v-else class="imgdiag">
                      <div v-if="opacityPhoto.findingsOD.length > 0">
                        <span style="color: red; line-height: 12px">{{ opacityPhoto.findingsOD.join(", ") }}</span>
                      </div>
                      <br />
                    </div>
                  </td>
                  <td align="center">
                    <p class="field-rl">Left Eye</p>

                    <img v-if="imgOpaOS" :src="imgOpaOS" class="img-responsive" alt="Lens Opacity Image OS"
                      style="width: 300px" />
                    <img v-else src="@/assets/img/imageNA.jpg" class="img-responsive" alt="Lens Opacity Image OS"
                      style="width: 250px" />

                    <div v-if="opacityPhoto.findingsOS[0] === 'Normal'">
                      <p class="field-norm">NORMAL</p>
                    </div>

                    <div v-else class="imgdiag">
                      <div v-if="opacityPhoto.findingsOS.length > 0">
                        <span style="color: red; line-height: 12px">{{ opacityPhoto.findingsOS.join(", ") }}</span>
                      </div>
                      <br />
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>

            <!-- OPACITY SINGLE IMAGE LAYOUT -->
            <table v-if="!imgOpaOS && imgOpaOD" class="report" style="width: 100%">
              <tbody>
                <tr align="right" style="line-height: 12px">
                  <td class="label" align="left">Lens Opacity / Cataract Grading:</td>
                  <td class="label" align="left">&nbsp;</td>
                </tr>
                <tr align="right">
                  <td align="center">
                    <div style="display: flex; width: 700px">
                      <div style="display: flex; align-items: center; justify-content: center; width: 50%">
                        <p style="margin: 0; padding: 0" class="field-rl">Right Eye</p>
                      </div>
                      <div style="display: flex; align-items: center; justify-content: center; width: 50%">
                        <p style="margin: 0; padding: 0" class="field-rl">Left Eye</p>
                      </div>
                    </div>
                    <img v-if="imgOpaOD" :src="imgOpaOD" class="img-responsive" alt="Lens Opacity Image OD"
                      style="width: 700px" />
                    <div style="display: flex; width: 700px">
                      <div style="width: 50%">
                        <div v-if="opacityPhoto.findingsOD[0] === 'Normal'">
                          <p class="field-norm">NORMAL</p>
                        </div>
                        <div v-else class="imgdiag">
                          <div v-if="opacityPhoto.findingsOD.length > 0">
                            <span style="color: red; line-height: 12px">{{ opacityPhoto.findingsOD.join(", ") }}</span>
                          </div>
                          <br />
                        </div>
                      </div>
                      <div style="width: 50%">
                        <div v-if="opacityPhoto.findingsOS[0] === 'Normal'">
                          <p class="field-norm">NORMAL</p>
                        </div>
                        <div v-else class="imgdiag">
                          <div v-if="opacityPhoto.findingsOS.length > 0">
                            <span style="color: red; line-height: 12px">{{ opacityPhoto.findingsOS.join(", ") }}</span>
                          </div>
                          <br />
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>

            <hr style="margin-top: 7px; margin-bottom: 3px" />

            <!--FUNDUS-->
            <table class="report" style="width: 100%">
              <tbody>
                <tr align="right" style="line-height: 12px">
                  <td class="label" align="left">Retina and Optic Nerve Photos:</td>
                  <td class="label" align="left">&nbsp;</td>
                </tr>
                <tr align="right" style="line-height: 12px">
                  <td align="center">
                    <p class="field-rl">Right Eye</p>

                    <img v-if="imgFunOD" :src="imgFunOD" class="img-responsive" alt="Fundus Photo OD"
                      style="width: 250px" />
                    <img v-else src="@/assets/img/imageNA.jpg" class="img-responsive" alt="Fundus Photo OD"
                      style="width: 250px" />

                    <div v-if="fundusPhoto.findingsOD[0] === 'Normal'">
                      <p class="field-norm">NORMAL</p>
                    </div>

                    <div v-else class="imgdiag">
                      <div v-if="fundusPhoto.findingsOD.length > 0">
                        <span style="color: red; line-height: 12px">{{ fundusPhoto.findingsOD.join(", ") }}</span>
                      </div>
                      <br />
                    </div>
                  </td>
                  <td align="center">
                    <p class="field-rl">Left Eye</p>

                    <img v-if="imgFunOS" :src="imgFunOS" class="img-responsive" alt="Fundus Photo OS"
                      style="width: 250px" />
                    <img v-else src="@/assets/img/imageNA.jpg" class="img-responsive" alt="Fundus Photo OS"
                      style="width: 250px" />

                    <div v-if="fundusPhoto.findingsOS[0] === 'Normal'">
                      <p class="field-norm">NORMAL</p>
                    </div>

                    <div v-else class="imgdiag">
                      <div v-if="fundusPhoto.findingsOS.length > 0">
                        <span style="color: red; line-height: 12px">{{ fundusPhoto.findingsOS.join(", ") }}</span>
                      </div>
                      <br />
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>

            <hr style="margin-top: 7px; margin-bottom: 3px" />

            <!--Mac-->
            <table class="report" style="width: 100%">
              <tbody>
                <tr align="right" style="line-height: 12px">
                  <td class="label" align="left">Macular OCT:</td>
                  <td class="label" align="left">&nbsp;</td>
                </tr>
                <tr align="right" style="line-height: 12px">
                  <td align="center">
                    <p class="field-rl">Right Eye</p>

                    <img v-if="imgMacOD" :src="imgMacOD" class="img-responsive" alt="Macual OCT OD"
                      style="width: 175px" />
                    <img v-else src="@/assets/img/imageNA.jpg" class="img-responsive" alt="Macual OCT OD"
                      style="width: 250px" />

                    <div v-if="maculaPhoto.findingsOD[0] === 'Normal'">
                      <p class="field-norm">NORMAL</p>
                    </div>

                    <div v-else class="imgdiag">
                      <div v-if="maculaPhoto.findingsOD.length > 0">
                        <span style="color: red; line-height: 12px">{{ maculaPhoto.findingsOD.join(", ") }}</span>
                      </div>
                      <br />
                    </div>
                  </td>
                  <td align="center">
                    <p class="field-rl">Left Eye</p>

                    <img v-if="imgMacOS" :src="imgMacOS" class="img-responsive" alt="Macual OCT OS"
                      style="width: 175px" />
                    <img v-else src="@/assets/img/imageNA.jpg" class="img-responsive" alt="Macual OCT OS"
                      style="width: 250px" />

                    <div v-if="maculaPhoto.findingsOS[0] === 'Normal'">
                      <p class="field-norm">NORMAL</p>
                    </div>
                    <div v-else class="imgdiag">
                      <div v-if="maculaPhoto.findingsOS.length > 0">
                        <span style="color: red; line-height: 12px">{{ maculaPhoto.findingsOS.join(", ") }}</span>
                      </div>
                      <br />
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>

            <hr style="margin-top: 7px; margin-bottom: 3px" />

            <!--RNFL-->
            <table class="report" style="width: 100%">
              <tbody>
                <tr align="right" style="line-height: 12px">
                  <td class="label" align="left">Retinal Nerve Fiber Layer:</td>
                  <td class="label" align="left">&nbsp;</td>
                </tr>
                <tr align="right" style="line-height: 12px">
                  <td align="center">
                    <p class="field-rl">Right Eye</p>

                    <img v-if="imgNrvOD" :src="imgNrvOD" class="img-responsive" alt="Optic Nerve OCT OD"
                      style="width: 175px" />
                    <img v-else src="@/assets/img/imageNA.jpg" class="img-responsive" alt="Optic Nerve OCT OD"
                      style="width: 250px" />

                    <div v-if="nervePhoto.findingsOD[0] === 'Normal'">
                      <p class="field-norm">NORMAL</p>
                    </div>
                    <div v-else class="imgdiag">
                      <div v-if="nervePhoto.findingsOD.length > 0">
                        <span style="color: red; line-height: 12px">{{ nervePhoto.findingsOD.join(", ") }}</span>
                      </div>
                      <br />
                    </div>
                  </td>
                  <td align="center">
                    <p class="field-rl">Left Eye</p>

                    <img v-if="imgNrvOS" :src="imgNrvOS" class="img-responsive" alt="Optic Nerve OCT OS"
                      style="width: 175px" />
                    <img v-else src="@/assets/img/imageNA.jpg" class="img-responsive" alt="Optic Nerve OCT OS"
                      style="width: 250px" />
                    <!-- <img v-else src="/globechek-files/rptAssets/img/imageNA.jpg?sv=2022-11-02&ss=bf&srt=sco&sp=rwdlacitfx&se=2024-12-02T21:45:40Z&st=2023-12-02T13:45:40Z&spr=https&sig=7yX7FrCQ4q4HgvpbUK3kKFZFaRMhG9F9F033EhNyVNA%3D" class="img-responsive" alt="Optic Nerve OCT OD" style="width: 250px"> -->

                    <div v-if="nervePhoto.findingsOS[0] === 'Normal'">
                      <p class="field-norm">NORMAL</p>
                    </div>
                    <div v-else class="imgdiag">
                      <div v-if="nervePhoto.findingsOS.length > 0">
                        <span style="color: red; line-height: 12px">{{ nervePhoto.findingsOS.join(", ") }}</span>
                      </div>
                      <br />
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>

            <h2>&nbsp;</h2>
            <br />
            <hr style="margin-bottom: 10px" />

            <div class="row">
              <div style="text-align: Left; margin-bottom: 10px; font-weight: 500px">
                <h5 class="big">Summary and Recommendations</h5>
              </div>
              <ol>
                <li class="rd2" align="Left">
                  <b>Diagnosis based on above screening:</b>
                  <p>
                    <span class="rd3" v-html="eval.outcomes.diagnoseHtml"></span>
                  </p>
                </li>

                <br />

                <li class="rd2" align="Left">
                  <b>Recommended follow-up:</b>
                  <p>
                    <span class="rd3" v-html="eval.outcomes.recommendHtml"></span>
                  </p>
                </li>
                <br />

                <li v-if="eval.referrals && eval.referrals.length > 0" class="rd2" align="Left">
                  <b>Recommended Doctors:</b>

                  <ol v-for="item in this.eval.referrals" :key="item.index">
                    <table style="width: 100%">
                      <tbody>
                        <tr>
                          <td colspan="1" valign="top" style="margin: 0; padding: 0; line-height: 16px">
                            <p>
                              <b>{{ item.name }}</b>
                            </p>
                            <p>{{ item.occupation }}</p>
                            <p class="rd3">{{ item.practice }}</p>
                          </td>
                          <td colspan="1" valign="top" style="margin: 0; padding: 0; line-height: 16px">
                            <p class="rd3">{{ item.address }}</p>
                            <p class="rd3">{{ item.city }},&nbsp;{{ item.state }}&nbsp;{{ item.zip }}</p>
                          </td>
                          <td colspan="1" valign="top" style="margin: 0; padding: 0; line-height: 16px">
                            <p>
                              <span class="rd3">{{ item.phone }}</span>
                            </p>
                            <p>
                              <b><a :href="'https://' + item.web" rel="noopener">{{ item.web }}</a></b>
                            </p>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </ol>
                </li>
                <p v-else style="line-height: 0.2"><br /></p>
                <!-- required to preserve formating -->
                <br />
              </ol>
            </div>

            <hr style="margin-bottom: 10px" />

            <div style="text-align: Left; margin-bottom: 10px; font-weight: 500px">
              <h5 class="big">ICD10 Code(s)</h5>
              <p v-html="formattedICD10.replace(/\n/g, '<br>')"></p>
            </div>

            <hr style="margin-bottom: 10px" />

            <div style="text-align: Left; margin-bottom: 10px; font-weight: 500px">
              <h5 class="big">CPT Code(s)</h5>
              <p v-html="formattedCPT.replace(/\n/g, '<br>')"></p>
            </div>

            <hr style="margin-bottom: 12px" />

            <div v-if="!isTeam()" style="margin-left: 30px; margin-right: 30px" align="Left">
              <h4><b>GlobeChek &trade;</b>&nbsp; Disclaimer:</h4>   
              <div class="disclaimer" style="margin-top: 5px" align="Left">
                Your exam results were interpreted by a board-certified ophthalmologist or optometrist.
                <i>GlobeChek</i>&trade; recommends regular eye exams as directed by the
                <i>American Academy of Ophthalmology</i> as well as the <i>American Optometric Association</i>. Do not
                disregard professional medical advice or delay in seeking it because of this exam. If you believe you
                may have a medical emergency, contact emergency care, visit an emergency room, or call 911 immediately.
              </div>
            </div>

            <div v-else>
              <section class="jaglogo" style="margin: auto">
                <img id="jaglogo" src="rptAssets/img/JAGS_logo.png" class="img-responsive" alt="JAGUARS Logo"
                  style="width: 500px" />
              </section>
            </div>

            <br />
            <div style="text-align: center">
              <h3 style="text-align: center">* * *</h3>
            </div>
          <hr style="height: 2px; margin-top: 10px; margin-bottom: 25px; background-color: #275" />


            <article id="member" style="line-height: 1.8rem">
              <section>
                <dl id="info-screen">
                  <dt class="mtitle"><b>Electronic Signature</b></dt>
                  <dd></dd>
        
                  <dt class="mtitle">&nbsp;&nbsp;&nbsp;Medical services perfomed by</dt>
                  <dd>{{ getServiceProvider }}</dd>
                  <dt class="mtitle">&nbsp;&nbsp;&nbsp;Electronically signed by</dt>
                  <dd>
                    <strong>
                      <i>{{ getReadingDoctor }}</i>
                    </strong>
                  </dd>
<!--                  <dt>* Valid for one year</dt>
                  <dd>{{ validDateRange }}</dd> -->
                </dl>
              </section>
            </article>

          <hr style="height: 2px; margin-top: 10px; margin-bottom: 25px; background-color: #275" />

          </div>
          <!-- PDF REPORT (END) -->

          <hr style="margin-top: 30px; margin-bottom: 60px" />
          <div class="page-break" style="page-break-after: always"></div>

          <!-- PDF REPORT (START) -->
          <div v-if="rxDispensed" id="pdfRx" style="margin: 5px">
            <article id="heading">
              <section style="visibility: hidden">
                <span>GlobeChek, LLC</span> <br />
                <span>1-877-GlobeChek</span> <br />
                <span>www.GlobeChek.com</span>
              </section>
              <section class="gclogo">
                <img src="@/assets/img/GlobeChek2.png" alt="GlobeChek" id="gclogo" class="img-responsive" />
              </section>
              <section>
                <span>GlobeChek, LLC</span> <br />
                <span>1-877-GlobeChek</span> <br />
                <span>www.GlobeChek.com</span>
              </section>
            </article>

            <br />
            <hr style="height: 3px; margin-top: 10px; margin-bottom: 10px; background-color: #275" />

            <article id="member">
              <section>
                <h4>&nbsp;</h4>
                <dl id="info-screen">
                  <dt class="mtitle">PATIENT</dt>
                  <dd>&nbsp;&nbsp; {{ eval.patientInfo.firstName }}&nbsp;{{ eval.patientInfo.lastName }}</dd>
                  <br />
                  <dt class="mtitle">DOB</dt>
                  <dd>
                    &nbsp;&nbsp;
                    {{ getDob }}
                  </dd>
                  <dt class="mtitle">ADDRESS</dt>
                  <dd>
                    &nbsp;&nbsp;
                    {{ eval.patientInfo.address.addressLn1 }}
                    {{ eval.patientInfo.address.addressLn2 }}
                    {{ eval.patientInfo.address.city }} &nbsp; {{ eval.patientInfo.address.state }} &nbsp;
                    {{ eval.patientInfo.address.zip }} &nbsp;
                  </dd>
                  <dt class="mtitle">HOME PHONE</dt>
                  &nbsp;&nbsp;
                  <dd>(212) 555-5555</dd>
                  <dt class="mtitle">CELL PHONE</dt>
                  &nbsp;&nbsp;
                  <dd>(212) 555-3333</dd>
                </dl>
              </section>
              <section>
                <h4><b>GLASSES PRESCRIPTION</b></h4>
                <br />
                <dl id="info-address">
                  <dt class="mtitle">ENCOUNTER DATE</dt>
                  &nbsp;&nbsp;
                  <dd>{{ getScreenDate }}</dd>
                  <br />
                  <dt class="mtitle">PROVIDER</dt>
                  &nbsp;&nbsp;
                  <dd>{{ getServiceProvider }}</dd>
                </dl>
              </section>
            </article>

            <br />
            <hr style="height: 2px; margin-top: 10px; margin-bottom: 25px; background-color: #275" />

            <article id="screening" style="line-height: 1.75rem">
              <div id="pdf-content" style=" overflow-x: hidden;">
              <table :style="screeningTable" class="screening-table">
                <thead>
                  <tr>
                    <th :style="cellStyle"></th>
                    <th :style="cellStyle">SPHERE</th>
                    <th :style="cellStyle">CYLINDER</th>
                    <th :style="cellStyle">AXIS</th>
                    <th :style="cellStyle">ADD</th>
                    <th :style="cellStyle">VA</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th :style="cellStyle" class="heading">Right</th>
                    <td :style="cellStyle"><b>{{ formatSigned(rxValues.odSPH) }}</b></td>
                    <td :style="cellStyle"><b>{{ formatSigned(rxValues.odCYL) }}</b></td>
                    <td :style="cellStyle">
                      <b>{{ rxValues.odAXS }}<span v-if="rxValues.odAXS != null && rxValues.odAXS > 0">&deg;</span></b>
                    </td>
                    <td :style="cellStyle"><b>{{ formatSigned(rxValues.odPOW) }}</b></td>
                    <td :style="cellStyle"><b>{{ formatAcuity(rxValues.odDIS) }}</b></td>
                  </tr>
                  <tr>
                    <th :style="cellStyle" class="heading">Left</th>
                    <td :style="cellStyle"><b>{{ formatSigned(rxValues.osSPH) }}</b></td>
                    <td :style="cellStyle"><b>{{ formatSigned(rxValues.osCYL) }}</b></td>
                    <td :style="cellStyle">
                      <b>{{ rxValues.osAXS }}<span v-if="rxValues.osAXS != null && rxValues.osAXS > 0">&deg;</span></b>
                    </td>
                    <td :style="cellStyle"><b>{{ formatSigned(rxValues.osPOW) }}</b></td>
                    <td :style="cellStyle"><b>{{ formatAcuity(rxValues.osDIS) }}</b></td>
                  </tr>
                </tbody>
              </table>
              </div>
            </article>

            <dl align="left" style="margin-top: 1rem">
              <dt colspan="5" style="font-size: 1rem; font-weight: 700; ">Comments:</dt>
              <dt colspan="5">{{ rxValues.ouCOM }}</dt>
              <dt class="spacer rl-top" style="font-size: 0.9rem">&nbsp;</dt>
            </dl>

            <hr style="height: 2px; margin-top: 250px; margin-bottom: 20px; background-color: #275" />

            <article id="member" style="line-height: 1.8rem">
              <section>
                <dl id="info-screen">
                  <dt class="mtitle"><b>Electronic Signature</b></dt>
                  <dd></dd>
                  <dt class="mtitle">&nbsp;&nbsp;&nbsp;Medical services perfomed by</dt>
                  <dd>{{ getServiceProvider }}</dd>
                  <dt class="mtitle">&nbsp;&nbsp;&nbsp;Signed by</dt>
                  <dd>
                    <strong><i>{{ getReadingDoctor }}</i></strong>
                  </dd>
                  <dd></dd>
                  <dd></dd>
                  <dt>* Valid for one year</dt>
                  <dd>{{ validDateRange }}</dd>
                  <dd></dd>
                </dl>
              </section>
            </article>

            <hr style="height: 2px; margin-top: 20px; margin-bottom: 5px; background-color: #275" />
          </div>
          
          <!-- PDF CONTACT RX REPORT (START) -->

          <div v-if="contactRxDispensed" id="pdfRx" style="margin: 5px">
            <article id="heading">
              <section style="visibility: hidden">
                <span>GlobeChek, LLC</span> <br />
                <span>1-877-GlobeChek</span> <br />
                <span>www.GlobeChek.com</span>
              </section>
              <section class="gclogo">
                <img src="@/assets/img/GlobeChek2.png" alt="GlobeChek" id="gclogo" class="img-responsive" />
              </section>
              <section>
                <span>GlobeChek, LLC</span> <br />
                <span>1-877-GlobeChek</span> <br />
                <span>www.GlobeChek.com</span>
              </section>
            </article>

            <br />
            <hr style="height: 3px; margin-top: 10px; margin-bottom: 10px; background-color: #275" />
            <article id="member">
              <section>
                <h4>&nbsp;</h4>
                <dl id="info-screen">
                  <dt class="mtitle">PATIENT</dt>
                  <dd>&nbsp;&nbsp; {{ eval.patientInfo.firstName }}&nbsp;{{ eval.patientInfo.lastName }}</dd>
                  <br />
                  <dt class="mtitle">DOB</dt>
                  <dd>
                    &nbsp;&nbsp;
                    {{ getDob }}
                  </dd>
                  <dt class="mtitle">ADDRESS</dt>
                  <dd>
                    &nbsp;&nbsp;
                    {{ eval.patientInfo.address.addressLn1 }}
                    {{ eval.patientInfo.address.addressLn2 }}
                    {{ eval.patientInfo.address.city }} &nbsp; {{ eval.patientInfo.address.state }} &nbsp;
                    {{ eval.patientInfo.address.zip }} &nbsp;
                  </dd>
                  <dt class="mtitle">HOME PHONE</dt>
                  &nbsp;&nbsp;
                  <dd>(212) 555-5555</dd>
                  <dt class="mtitle">CELL PHONE</dt>
                  &nbsp;&nbsp;
                  <dd>(212) 555-3333</dd>
                </dl>
              </section>
              <section>
                <h4><b>CONTACT PRESCRIPTION</b></h4>
                <br />
                <dl id="info-address">
                  <dt class="mtitle">ENCOUNTER DATE</dt>
                  &nbsp;&nbsp;
                  <dd>{{ getScreenDate }}</dd>
                  <br />
                  <dt class="mtitle">PROVIDER</dt>
                  &nbsp;&nbsp;
                  <dd>{{ getServiceProvider }}</dd>
                </dl>
              </section>
            </article>
            <br />
            <hr style="height: 2px; margin-top: 10px; margin-bottom: 25px; background-color: #275" />

            <article id="screening" style="line-height: 1.75rem">
              <div id="pdf-content" class="scroll-container" >
              <table :style="screeningTableContact" class="screening-table-contact">
                <thead>
                  <tr>
                    <th :style="cellStyle"></th>
                    <th :style="cellStyle">SPHERE</th>
                    <th :style="cellStyle">CYLINDER</th>
                    <th :style="cellStyle">AXIS</th>
                    <th :style="cellStyle">ADD</th>
                    <th :style="cellStyle">VA</th>
                    <th :style="cellStyle">BASE CURVE</th>
                    <th :style="cellStyle">DIAMETER</th>
                    <th :style="cellStyle">BRAND</th>
                    <th :style="cellStyle">MANUFACTURER</th>
                    <th :style="cellStyle">COLOR/MF PWR</th>
                    <th :style="cellStyle">QTY</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th :style="cellStyle" class="heading">Right</th>
                    <td :style="cellStyle"><b>{{ formatSigned(rxContactValues.odSPH) }}</b></td>
                    <td :style="cellStyle"><b>{{ formatSigned(rxContactValues.odCYL) }}</b></td>
                    <td :style="cellStyle"><b>{{ rxContactValues.odAXS }}<span v-if="rxContactValues.odAXS != null && rxContactValues.odAXS > 0">&deg;</span></b></td>
                    <td :style="cellStyle"><b>{{ formatSigned(rxContactValues.odPOW) }}</b></td>
                    <td :style="cellStyle"><b>{{ formatAcuity(rxContactValues.odDIS) }}</b></td>
                    <td :style="cellStyle"><b>{{ rxContactValues.odBC }}</b></td>
                    <td :style="cellStyle"><b>{{ rxContactValues.odDIA }}</b></td>
                    <td :style="cellStyle"><b>{{ rxContactValues.odBRA }}</b></td>
                    <td :style="cellStyle"><b>{{ rxContactValues.odMAN }}</b></td>
                    <td :style="cellStyle"><b>{{ rxContactValues.odCOL }}</b></td>
                    <td :style="cellStyle"><b>{{ rxContactValues.odQT }}</b></td>
                  </tr>
                  <tr>
                    <th :style="cellStyle" class="heading">Left</th>
                    <td :style="cellStyle"><b>{{ formatSigned(rxContactValues.osSPH) }}</b></td>
                    <td :style="cellStyle"><b>{{ formatSigned(rxContactValues.osCYL) }}</b></td>
                    <td :style="cellStyle"><b>{{ rxContactValues.osAXS }}<span v-if="rxContactValues.osAXS != null && rxContactValues.osAXS > 0">&deg;</span></b></td>
                    <td :style="cellStyle"><b>{{ formatSigned(rxContactValues.osPOW) }}</b></td>
                    <td :style="cellStyle"><b>{{ formatAcuity(rxContactValues.osDIS) }}</b></td>
                    <td :style="cellStyle"><b>{{ rxContactValues.osBC }}</b></td>
                    <td :style="cellStyle"><b>{{ rxContactValues.osDIA }}</b></td>
                    <td :style="cellStyle"><b>{{ rxContactValues.osBRA }}</b></td>
                    <td :style="cellStyle"><b>{{ rxContactValues.osMAN }}</b></td>
                    <td :style="cellStyle"><b>{{ rxContactValues.osCOL }}</b></td>
                    <td :style="cellStyle"><b>{{ rxContactValues.osQT }}</b></td>
                  </tr>
                </tbody>
              </table>
              </div>
            </article>

            <dl align="left" style="margin-top: 1rem">
              <dt colspan="5" style="font-size: 1rem; font-weight: 700; ">Comments:</dt>
              <dt colspan="5">{{ rxContactValues.ouCOM }}</dt>
              <dt class="spacer rl-top" style="font-size: 0.9rem">&nbsp;</dt>
            </dl>

            <hr style="height: 2px; margin-top: 250px; margin-bottom: 20px; background-color: #275" />

            <article id="member" style="line-height: 1.8rem">
              <section>
                <dl id="info-screen">
                  <dt class="mtitle"><b>Electronic Signature</b></dt>
                  <dd></dd>
                  <dt class="mtitle">&nbsp;&nbsp;&nbsp;Medical services perfomed by</dt>
                  <dd>{{ getServiceProvider }}</dd>
                  <!-- <dt class="mtitle">&nbsp;&nbsp;&nbsp;Electronically signed by</dt> -->
                  <dt class="mtitle">&nbsp;&nbsp;&nbsp;Signed by</dt>
                  <dd>
                    <strong><i>{{ getReadingDoctor }}</i></strong>
                  </dd>
                  <dd></dd>
                  <dd></dd>
                  <dt>* Valid for one year</dt>
                  <dd>{{ validDateRange }}</dd>
                  <dd></dd>
                </dl>
              </section>
            </article>

            <hr style="height: 2px; margin-top: 20px; margin-bottom: 5px; background-color: #275" />
          </div>
          <!-- PDF REPORT (END) -->
        </div>
      </md-card-content>
    </md-card>
  </div>
</template>

<script>
import Swal from "sweetalert2"
import moment from "moment"
import { mapGetters, mapActions } from "vuex"
import { v4 as uuidv4 } from "uuid"
export default {
  name: "ReportPreview",
  components: {},
  props: ["viewonly", "rxValues", "rxContactValues"],
  data() {
    return {
      state: "",
      status: "",
      branding: false,
      API_SERVICE: process.env.VUE_APP_URL,
      PREREG_API: process.env.VUE_APP_PREREG,
      APP_HOST: process.env.VUE_APP_HOST,
      APP_EMAIL_HOST: process.env.VUE_APP_EMAIL_HOST,
      token: process.env.VUE_APP_TOKEN,
      creds: null,
      externalPhoto: { findingsOD: [], findingsOS: [] },
      corneaPhoto: { findingsOD: [], findingsOS: [] },
      pachymetryPhoto: { findingsOD: [], findingsOS: [] },
      opacityPhoto: { findingsOD: [], findingsOS: [] },
      fundusPhoto: { findingsOD: [], findingsOS: [] },
      maculaPhoto: { findingsOD: [], findingsOS: [] },
      nervePhoto: { findingsOD: [], findingsOS: [] },
      cellStyle: {
        border: '1px solid #ccc',
        padding: '0.5rem',
        textAlign: 'center',
        whiteSpace: 'normal',
        overflowWrap: 'break-word',
        wordBreak: 'break-word',
        maxWidth: '100px',
      },

      screeningTableContact: {
        width: 'max-content',
        maxWidth: '100%',
        borderCollapse: 'collapse',
        tableLayout: 'fixed',
        fontSize: '0.75rem',
      },
      screeningTable: {
        width: '100%',
        borderCollapse: 'collapse',
        tableLayout: 'fixed',
        fontSize: '0.75rem'
      },
      rxDispensed: sessionStorage.getItem("rxDispensed") === "true",
      contactRxDispensed: sessionStorage.getItem("contactRxDispensed") === "true"
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.listAllImages()
      this.processFindings()
    }),
    window.addEventListener("storage", this.syncStorage);
  },
  beforeDestroy() {
    window.removeEventListener("storage", this.syncStorage);
  },
  computed: {
    ...mapGetters(["eval", "screeningID", "imagesPath", "icd10State", "cptState", "getSignedImages", "dxOptionsList"]),
    validDateRange() {
      const start = new Date();
      const end = new Date();
      end.setFullYear(start.getFullYear() + 1);
    
      const options = { year: 'numeric', month: 'numeric', day: 'numeric' };
    
      const formattedStart = start.toLocaleDateString('en-US', options);
      const formattedEnd = end.toLocaleDateString('en-US', options);
    
      return `${formattedStart} - ${formattedEnd}`;
    },
    pupillaryDistance_OD() {
      return this.eval.visionInfo.visionComments.split("|")[3] || "n/a"
    },

    pupillaryDistance_OS() {
      return this.eval.visionInfo.visionComments.split("|")[4] || "n/a"
    },

    pupillaryDistanceAGG() {
      if (this.pupillaryDistance_OD !== "n/a" && this.pupillaryDistance_OS !== "n/a") {
        return `[${Math.round(Number(this.pupillaryDistance_OD) + Number(this.pupillaryDistance_OS))}]`
      }
      return ""
    },

    getDob() {
      return moment(this.eval.patientInfo.dob, "YYYY-MM-DD").format("l")
    },

    getAge() {
      return moment().diff(this.eval.patientInfo.dob, "years")
    },

    getScreenDate() {
      return moment(this.eval.screeningInfo.screeningDate).format("dddd MMMM Do, YYYY")
    },

    imgExt() {
      const externalImages = this.getSignedImages.external
      if (!externalImages || externalImages.length === 0) return false

      const portrait = externalImages.find((img) => img.file && img.file.includes("Portrait"))
      return portrait ? portrait.url : false
    },
    imgCorOD() {
      return this.getImageUrl("cornea", ["COROD"])
    },
    imgCorOS() {
      return this.getImageUrl("cornea", ["COROS"])
    },
    imgPacOD() {
      return this.getImageUrl("pachymetry", ["PACOD"])
    },
    imgPacOS() {
      return this.getImageUrl("pachymetry", ["PACOS"])
    },
    imgOpaOD() {
      return this.getImageUrl("opacity", ["OPAODOS"])
    },
    imgOpaOS() {
      return this.getImageUrl("opacity", ["OPAOS"])
    },
    imgFunOD() {
      return this.getImageUrl("fundus", ["FUNMACOD", "FUN_3"])
    },
    imgFunOS() {
      return this.getImageUrl("fundus", ["FUNMACOS", "FUN_4"])
    },
    imgMacOD() {
      return this.getImageUrl("macula", ["MACOD"])
    },
    imgMacOS() {
      return this.getImageUrl("macula", ["MACOS"])
    },
    imgNrvOD() {
      return this.getImageUrl("nerve", ["NRVOD"])
    },
    imgNrvOS() {
      return this.getImageUrl("nerve", ["NRVOS"])
    },

    viOD() {
      return this.eval.visionInfo.autoRefractionOD
    },
    viOS() {
      return this.eval.visionInfo.autoRefractionOS
    },
    OD_Sph() {
      if (this.viOD) {
        var ods = this.viOD.slice(0, this.viOD.indexOf(" "))
        return ods
      } else {
        return "n/a"
      }
    },
    OD_Cyl() {
      if (this.viOD) {
        var odc = this.viOD.slice(this.viOD.indexOf(" "), this.viOD.indexOf("x"))
        return odc
      } else {
        return "n/a"
      }
    },
    OD_Axis() {
      if (this.viOD) {
        var oda = this.viOD.slice(this.viOD.indexOf("x") + 1)
        return oda
      } else {
        return "n/a"
      }
    },
    OS_Sph() {
      if (this.viOS) {
        var ods = this.viOS.slice(0, this.viOS.indexOf(" "))
        return ods
      } else {
        return "n/a"
      }
    },
    OS_Cyl() {
      if (this.viOS) {
        var odc = this.viOS.slice(this.viOS.indexOf(" "), this.viOS.indexOf("x"))
        return odc
      } else {
        return "n/a"
      }
    },
    OS_Axis() {
      if (this.viOS) {
        var oda = this.viOS.slice(this.viOS.indexOf("x") + 1)
        return oda
      } else {
        return "n/a"
      }
    },
    OD_Angle() {
      if (this.eval.visionInfo.angleMeasurementOD.includes("None")) {
        return "n/a"
      }
      return this.eval.visionInfo.angleMeasurementOD.replaceAll("°", "<sup>o</sup>")
    },
    OS_Angle() {
      if (this.eval.visionInfo.angleMeasurementOS.includes("None")) {
        return "n/a"
      }
      return this.eval.visionInfo.angleMeasurementOS.replaceAll("°", "<sup>o</sup>")
    },
    colorOD() {
      if (this.eval.visionInfo.visionComments) {
        var colR = this.eval.visionInfo.visionComments.split("|")[0]
        return colR
      }
    },
    getServiceProvider() {
      return sessionStorage.getItem("OrgBusiness")
    },
    getReadingDoctor() {
      const evalUser = this.eval && this.eval.lastUpdateByUser
      const evalUserType = evalUser ? evalUser.userType : null
      const evalUserName = evalUser ? evalUser.name : null
    
      const sessionUserType = sessionStorage.getItem("usertype")
      const sessionUser = sessionStorage.getItem("firstname") + " " + sessionStorage.getItem("lastname")
    
      if (evalUser && evalUserType !== "Technician" && evalUserType !== "Admin") {
        return evalUserName
      }
    
      if (sessionUserType !== "Technician" && sessionUserType !== "Admin") {
        return sessionUser
      }
    
      return ""
    },

    getNewGuid() {
      return uuid()
    },
    formattedICD10() {
      return Array.isArray(this.icd10State)
        ? this.icd10State.map((item) => `${item.code} - ${item.description}`).join("\n")
        : this.icd10State
    },
    formattedCPT() {
      return Array.isArray(this.cptState)
        ? this.cptState.map((item) => `${item.description}`).join("\n")
        : this.cptState
    },
  },
  watch: {
    rxDispensed(newVal) {
      sessionStorage.setItem("rxDispensed", newVal ? "true" : "false");
    },
    contactRxDispensed(newVal) {
      sessionStorage.setItem("contactRxDispensed", newVal ? "true" : "false");
    }
  },
  methods: {
    ...mapActions(["imagePickerList", "generateHtmlReport", "generatePdfReport", "getSignedReport"]),
    async saveIcd10AndCPT() {
      let screeningID = sessionStorage.getItem("screeningID")
      await window.axios.post(`${process.env.VUE_APP_URL}/icd10/screening/${screeningID}`, { icd10s: this.icd10State.map(i => i.code) }).catch((err) => {
        console.log("Error: saving ICD10", err)
      })
      await window.axios.post(`${process.env.VUE_APP_URL}/cpt/screening/${screeningID}`, { cpts: this.cptState.map(i => i.code) }).catch((err) => {
        console.log("Error: saving cpt", err)
      })
    },
    getImageUrl(category, ids = []) {
      const images = this.getSignedImages[category]
      if (!images || images.length === 0) return false

      const match = images.find((img) => ids.includes(img.id))
      return match ? match.url : false
    },
    listAllImages() {
      let payload = {
        pkgID: sessionStorage.getItem("storageID"),
        showPicker: false
      }
      this.$store.dispatch("imagePickerList", payload)
    },
    processFindings() {
      const safeText = (id) => {
        const el = document.getElementById(id)
        return el
          ? el.innerText
            .replace(/(OD:|OS:)/, "")
            .trim()
            .split(",")
            .filter((i) => !!i)
          : []
      }

      this.externalPhoto.findingsOD = safeText("External Photo-OD")
      this.externalPhoto.findingsOS = safeText("External Photo-OS")

      this.corneaPhoto.findingsOD = safeText("Corneal Topography-OD")
      this.corneaPhoto.findingsOS = safeText("Corneal Topography-OS")

      this.pachymetryPhoto.findingsOD = safeText("Anterior Segment OCT-OD")
      this.pachymetryPhoto.findingsOS = safeText("Anterior Segment OCT-OS")

      this.opacityPhoto.findingsOD = safeText("Lens Status-OD")
      this.opacityPhoto.findingsOS = safeText("Lens Status-OS")

      this.fundusPhoto.findingsOD = safeText("Fundus Photo-OD")
      this.fundusPhoto.findingsOS = safeText("Fundus Photo-OS")

      this.maculaPhoto.findingsOD = safeText("Macular OCT-OD")
      this.maculaPhoto.findingsOS = safeText("Macular OCT-OS")

      this.nervePhoto.findingsOD = safeText("Optic Nerve OCT-OD")
      this.nervePhoto.findingsOS = safeText("Optic Nerve OCT-OS")
    },
    isTeam: function () {
      if (
        process.env.VUE_APP_TITLE.substring(0, 5) == "BRAVE" ||
        process.env.VUE_APP_TITLE.substring(0, 5) == "JAGUA"
      ) {
        return true
      }
      return false
    },

    replaceChar(origString, replaceChar, index) {
      var newStringArray = origString.split("")
      newStringArray[index] = replaceChar
      var newString = newStringArray.join("")
      return newString
    },

    onCloseRPT() {
      this.$emit("onCloseRPT")
    },

    async onPrint() {
      this.state = "LOADING"
          // LOG FINDINGS to DB  (move to: OnGenerateReort after testing)
      this.$store.dispatch("updateFindingMetrics", null)
      try {
        const reportId = sessionStorage.getItem("storageID")
            const payload = {
              reportId
            }
        await this.saveIcd10AndCPT()
            await this.generateHtmlReport()
        await this.generatePdfReport(payload)
            if (this.viewonly == "True") {
              return
            }
            let screeningID = sessionStorage.getItem("screeningID")
            if (localStorage.getItem("ongoingScreenings")) {
              var ongoingScreenings = JSON.parse(localStorage.getItem("ongoingScreenings"))
              let filteredScreenings = ongoingScreenings.filter((id) => id != screeningID)
        localStorage.setItem("ongoingScreenings", JSON.stringify(filteredScreenings))
        if (localStorage.getItem(screeningID)) {
          localStorage.removeItem(screeningID)
              }
        }
      
        this.onCloseRPT()
        this.showSwal("message-and-cancel")
      } catch (error) {
        Swal.fire({
          title: "Error",
          text: "An error occurred while generating the report: " + error,
          confirmButtonText: "OK"
        })
      } finally {
        this.state = "FINISHED"
      }
    },

    async deleteRegistration() {
      var vm = this
      var url = vm.PREREG_API + "/" + "removereserve?token=" + vm.token + "&id=" + vm.eval.patientInfo.internalID
      //console.log("deleteRegistration:POST " + url);
      await window.axios.post(url).catch(function (error) {
        console.log("Error: Preregistration did not delete properly.")
        console.log("Error: " + error)
      })
    },

    generateReport: async function () {
      // this.$store.dispatch("updateFindingMetrics", null);

      try {
        const vm = this
        const _screeningID = vm.screeningID
        const _readerID = sessionStorage.getItem("userID")
        const _readerEmail = sessionStorage.getItem("username")
        const _readerName = sessionStorage.getItem("firstname") + " " + sessionStorage.getItem("lastname")
        const _patientUserID = sessionStorage.getItem("patientUserID")
        const _patientEmail = vm.eval.patientInfo.email
        const _patientName = vm.eval.patientInfo.firstName + " " + vm.eval.patientInfo.lastName

        const config = { headers: { "Content-Type": "application/json" } }
        const url = `${vm.API_SERVICE}/user/creds/${_patientEmail}`

        console.log("generateReport:GET " + url)
        const response = await window.axios.put(url, {}, config)
        console.log("CREDS: " + JSON.stringify(response.data))
        const _tmpPswd = response.data[0]

        vm.status = "Generating Screening Report . . . ."
        const data_A = {
          screeningID: sessionStorage.getItem("storageID"),
          orgID: sessionStorage.getItem("OrgID"),
          generatedby: sessionStorage.getItem("userID"),
          rptType: "PDF",
          status: "unread",
          createdBy: sessionStorage.getItem("userID")
        }
        const url_A = `${vm.API_SERVICE}/report/generate/`
        console.log("generateReport:POST " + url_A)
        await window.axios.post(url_A, data_A, config)

        vm.status = "Updating Screening Status . . . ."
        const _msgBody = `
            <html><body>
            <H3>Your GlobeChek screening report is ready.</h3>
            <br>
            <p>Please login to the GlobeChek Portal to review your GlobeChek report. </p>
            <p>Sign in <b><a href="${vm.APP_EMAIL_HOST}">HERE.<a/></b></P>
            <br><p>Your temporary password is: &nbsp; <i> ${_tmpPswd} </i>
            <br><br>
            </body></html>
          `
        const url_B = `${vm.API_SERVICE}/screening/${_screeningID}/Closed/${_readerID}`

        // console.log("generateReport:PUT " + url_B);
        await window.axios.put(url_B, null, config)

        vm.status = "Sending Message to Member . . . ."
        const data_C = {
          senderID: "Admin@GlobeChek.com",
          senderName: _readerName,
          recipientID: _patientUserID,
          recipientName: _patientName,
          msg_subject: "Your GlobeChek Report is ready.",
          msg_body: _msgBody,
          msg_level: "normal"
        }
        const url_C = `${vm.API_SERVICE}/msg/newmessage`
        console.log("Send Member Notification:POST " + url_C)
        await window.axios.post(url_C, data_C, config)

        vm.status = "Sending Report-Ready Email to Member...."
        const data_D = {
          sender_address: "info@globechek.com",
          recipient_address: _patientEmail,
          recipient_name: _patientName,
          msg_subject: "Your GlobeChek Report is ready . . . ."
        }
        const url_D = `${vm.API_SERVICE}/report-ready`
        await window.axios.post(url_D, data_D, config)

        // Add FILES Link to the REPORT
        const fileData = {
          Id: uuidv4().toString(),
          OrganisationID: sessionStorage.getItem("orgID"),
          FeatureName: "Screenings",
          FeatureID: sessionStorage.getItem("storageID"),
          Category: "REPORT",
          FileName: sessionStorage.getItem("storageID") + ".pdf",
          ContentType: "application/pdf",
          Description: sessionStorage.getItem("storageID") + ".pdf",
          FileUploaded: "",
          CreatedBy: sessionStorage.getItem("userID"),
          CreatedAt: new Date().toISOString().slice(0, 19).replace("T", " "),
          UpdatedBy: sessionStorage.getItem("userID"),
          UpdatedAt: new Date().toISOString().slice(0, 19).replace("T", " ")
        }
        const fileUrl = `${vm.API_SERVICE}/files/`

        // console.log("FILES-LINK_POST: " + fileUrl);
        // console.log("FILES-LINK_Payload: " + fileData);
        await window.axios.post(fileUrl, fileData, config)

        try {
          localStorage.removeItem(vm.screeningID)
          vm.deleteRegistration()
        } catch (error) {
          console.log(error)
        }

        vm.showSwal("auto-close")
        vm.$router.push(`${sessionStorage.getItem("portalRoute")}/screenings`)
      } catch (error) {
        console.error("An error occurred:", error)
        // Handle the error appropriately (e.g., show an error message)
      }
    },

    showSwal(type) {
      if (type === "auto-close") {
        Swal.fire({
          //title: "Success!",
          text: "Report Registered! - Notifications sent to patient",
          timer: 1500,
          showConfirmButton: false
        })
      } else if (type === "message-and-cancel") {
        Swal.fire({
          title: "Register this report?",
          text: "Notification will be sent to member to view results.",
          //type: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, Register it.",
          cancelButtonText: "No, Cancel",
          confirmButtonClass: "md-button md-success",
          cancelButtonClass: "md-button md-danger",
          buttonsStyling: false
        }).then((result) => {
          if (result.value) {
            this.generateReport()
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            Swal.fire({
              title: "Cancelled",
              text: "Nothing sent,  ...continuing with evaluaiton.",
              //type: "error",
              confirmButtonClass: "md-button md-info",
              buttonsStyling: false
            }).then(() => {
              return
            })
          }
        })
      }
    },

    referralIDs() {
      var ids = []
      this.eval.referrals.forEach((element) => {
        ids.push(element.id)
      })
      return ids.join(";")
    },
    formatSigned(value) {
      if (isNaN(parseFloat(value))) {
        return value; 
      }
      // 2 decimal places
      const num = parseFloat(value);
      const fixedValue = num.toFixed(2);
      // + or - 
      if (num > 0) {
        return `+${fixedValue}`;
      }
      return fixedValue;
    },
    formatAcuity(val) {
      if (val && val.toString().trim() !== "") {
        return `20/${val}`
      }
      return ""
    },
    syncStorage(event) {
      if (event.key === "rxDispensed") {
        this.rxDispensed = event.newValue;
      }
      if (event.key === "contactRxDispensed") {
        this.contactRxDispensed = event.newValue;
      }
    }
  }
}
</script>

<style lang="css" scoped>
.md-card {
  width: 95%;
  margin-left: 20px;
  display: inline-block;
  vertical-align: top;
}

@import url("https://fonts.googleapis.com/css?family=Roboto|Source+Sans+Pro:400,700");

@page {
  size: 8.5in 11in;
  margin: 0.4in 0.4in 0.4in 0.4in;

  @bottom-left {
    color: #1e5de4;
    font-family: Roboto;
    font-size: 0.7rem;
    font-style: italic;
    content: "What we see may save your sight!";
  }

  @bottom-right {
    color: #a9a;
    font-family: Roboto;
    font-size: 0.75rem;
    content: "info@globechek.com | 1-877-GlobeChek | www.GlobeChek.com";
  }
}

@media print {
  nav {
    display: none;
  }

  h1 {
    page-break-before: auto;
    break-before: auto;
  }

  h2 {
    page-break-before: auto;
    break-before: auto;
  }
}

.swal2-container {
  z-index: 2000 !important;
}

.gclogo {
  background: url("rptAssets/img/GlobeChek2.png") no-repeat;
  background-size: 140px 80px;
  width: 200px;
  height: 80px;
}

.gclogo img {
  display: none;
}

.jaglogo {
  background: url("rptAssets/img/JAGS_logo.png") no-repeat;
  background-size: 896px 207px;
  width: 896px;
  height: 207px;
}

.jaglogo img {
  display: none;
}

.crclogo {
  background: url("rptAssets/img/CRC_logo.png") no-repeat;
  background-size: 140px 80px;
  width: 200px;
  height: 80px;
  margin-left: auto;
  margin-right: auto;
}

.crclogo img {
  display: none;
}

html {
  color: #14213d;
  font-family: Roboto;
  font-size: 0.8rem;
  /* line-height: 1.6; */
}

html body {
  margin: 0;
}

html h1 {
  color: #1e5de4;
  font-family: Roboto;
  font-size: 40pt;
  margin: 0;
}

html hr {
  border: none;
  height: 0.5px;
  /* Set the hr color */
  color: #555;
  /* old IE */
  background-color: #555;
  /* Modern Browsers */
}

html body article#heading {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  font-size: 0.8rem;
  line-height: 0.95rem;
}

html body article#heading section span {
  font-size: 0.8rem;
  font-weight: 400;

  margin: 0 5px 0 0;
  /* T R B L */
  padding: 0;
  text-align: left;
}

html body article#member {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  font-size: 0.8rem;
  line-height: 1.2rem;
}

html body article#member section dl {
  text-align: left;
}

html body article#member section dl dt,
section dl dd {
  color: rgb(153, 159, 170);
  display: inline;
  margin: 0;
}

html body article#member section dl dt {
  color: rgb(38, 41, 46);
}

html body article#member section dl dt::before {
  content: "";
  display: block;
}

html body article#member section dl dt::after {
  content: ": ";
}

html body article#screening {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  font-size: 0.9rem;
  line-height: 1rem;
}

html body article#screening section dl {
  text-align: left;
}

html body article#screening section dl dt,
section dl dd {
  color: rgb(17, 70, 150);
  display: inline;
  margin: 0;
}

html body article#screening section dl dt {
  color: rgb(0, 0, 0);
}

html body article#screening section dl dt::before,
html body article#screening section dl dd {
  content: "";
  display: block;
}

html body article#screening section dl dt::after {
  content: "";
}

html body article#screening section dl dt.subhead {
  font-size: 0.75rem;
  color: rgb(78, 78, 109);
}

html body article#screening section dl dt.title {
  font-size: 0.75rem;
  font-weight: 500;
}

html body article#screening section dl dt.heading {
  font-size: 0.75rem;
  font-weight: 400;
  text-decoration: underline;
}

.spacer {
  margin-bottom: 4px;
}

.spacer2 {
  margin-bottom: 6px;
}

#imgExt {
  width: 20%;
  height: auto;
}

.rl-top {
  font-size: 0.73rem;
}

.label {
  font-size: 0.88rem;
  font-weight: 600;
}

.field-norm {
  font-size: 0.8rem;
  font-weight: 400;
  margin-top: 6px;
  color: blue;
}

.field-rl {
  font-size: 0.85rem;
  margin: 5px 0px 10px 0px;
  font-weight: 550;
}

.field-top {
  font-size: 0.7rem;
  padding: 0px;
}

.mtitle {
  font-weight: 500;
  font-family: Roboto;
}

.imgdiag {
  line-height: 0.75em;
  font-size: 0.72rem;
  padding: 0px;
  margin-top: 10px;
}

.exit-icon {
  position: sticky;
  top: 15px;
  right: 15px;
  float: right;
  cursor: pointer;
  z-index: 50;
  background-color: red !important;
}

.genrpt {
  position: sticky;
  top: 15px;
  left: 15px;
  float: left;
  cursor: pointer;
  z-index: 50;
  background-color: green !important;
  color: white;
}

::v-deep .rd2 {
  text-align: left;
}

::v-deep .big {
  font-size: 1.5em;
  font-weight: 500;
}

::v-deep .disclaimer {
  text-align: justify;
  text-justify: inter-word;
}

.page-break {
  page-break-after: always;
}

.description-box {
  white-space: pre-line;
  word-wrap: break-word;
  overflow-wrap: break-word;
  max-width: 100%;
  text-align: left;
}
</style>
